<template>
    <section class="q10__page my-14">
        <div class="container px-11 2xl:px-3 m-auto">
            <div class="q10__article_container__article_tour card">
                <!-- article title tour -->
                <article-title-tour
                        :options="{
                        tourtitle: currentPage.content.tourTitle.text,
                        titlecolor: 'text-selective_green',
                        toursubtitle: currentPage.content.tourSubTitle.text,
                        subtitlecolor: 'text-nandor',
                    }"
                ></article-title-tour>
            </div>
            <div class="container-components">
                <div class="card break-inside-avoid">
                    <div class="relative">
                        <hotspot-richmedia
                                :options="{
                                icon: 'diaporama',
                                collection: getRichmediaByCollection(
                                    currentPage,
                                    'Renouv’Eau, l’interview de JF Astolfi'
                                ),
                            }"
                                class="-top-3 md:top-0 -right-2"
                        />
                    </div>

                    <TimelineTitle
                            :options="{
                            year: currentPage.content.secondYear.text,
                            pretitle: currentPage.content.secondPreTitle.text,
                            title: currentPage.content.secondTitle.text,
                            content: currentPage.content.secondText.text,
                            fontSize: {},
                            color: {
                                year: 'text-selective_orange',
                                title: 'text-selective_green',
                                subtitle: 'text-red-500',
                                content: 'text-black',
                            },
                            fontSize: {
                                year: 'text-md md:text-lg lg:text-xl',
                                pretitle: 'text-xl 2xl:text-2xl',
                                title: 'text-3xl 2xl:text-4xl',
                                subtitle: 'text-2xl md:text-2xl lg:text-3xl',
                                content: 'text-md md:text-xl lg:text-base',
                            },
                        }"
                    >
                        <div class="mx-auto">
                            <image-with-descriptions
                                    class="mt-1 mb-1"
                                    :options="{
                                    image:
                                        'pages/' +
                                        currentPage.slug +
                                        '/' +
                                        currentPage.images.image2.src,
                                    descriptions: [
                                        {
                                            text: currentPage.images.image2
                                                .edf,
                                            position: 'bottom-right', // top/bottom-left/right
                                            orientation: 'horizontal', // vertical, horizontal
                                            fontSize: 'text-xs md:text-base',
                                        },
                                    ],
                                }"
                            />
                        </div>
                    </TimelineTitle>
                </div>

                <div class="card break-inside-avoid">
                    <div class="relative">
                        <hotspot-richmedia
                                :options="{
                                icon: 'diaporama',
                                collection: getRichmediaByCollection(
                                    currentPage,
                                    'Mulhouse déménage rue des Pâturages'
                                ),
                            }"
                                class="-top-3 md:top-0 -right-2"
                        />
                    </div>

                    <TimelineTitle
                            :options="{
                            year: currentPage.content.firstYear.text,
                            pretitle: currentPage.content.firstPreTitle.text,
                            title: currentPage.content.firstTitle.text,
                            content: currentPage.content.firstText.text,
                            fontSize: {},
                            color: {
                                year: 'text-selective_orange',
                                title: 'text-selective_green',
                                content: 'text-black',
                            },
                            fontSize: {
                                year: 'text-md md:text-lg lg:text-xl',
                                pretitle: 'text-xl 2xl:text-2xl',
                                title: 'text-3xl 2xl:text-4xl',
                                content: 'text-md md:text-xl lg:text-base',
                                outerText: 'text-md',
                            },
                        }"
                    >
                        <image-with-descriptions
                                class="mt-1 mb-1"
                                :options="{
                                image:
                                    'pages/' +
                                    currentPage.slug +
                                    '/' +
                                    currentPage.images.image1.src,
                                descriptions: [
                                    {
                                        text: currentPage.images.image1.edf,
                                        position: 'bottom-right', // top/bottom-left/right
                                        orientation: 'horizontal', // vertical, horizontal
                                        fontSize: 'text-xs md:text-base',
                                    },
                                ],
                            }"
                        />
                    </TimelineTitle>
                </div>

                <!--    container-timeline-title-si-image-with-description        -->
                <div class="card break-inside-avoid">
                    <div class="relative">
                        <image-with-descriptions
                                :options="{
                                image500:
                                    'pages/' +
                                    currentPage.slug +
                                    '/' +
                                    currentPage.images.image3.src,
                                descriptions: [
                                    {
                                        text: currentPage.images.image3.edf,
                                        position: 'bottom-right', // top/bottom-left/right
                                        orientation: 'horizontal', // vertical, horizontal
                                        fontSize: 'text-xs md:text-base',
                                    },
                                ],
                            }"
                        />
                    </div>
                    <div class="absolute top-0 left-0 p-8">
                        <TimelineTitle
                                :options="{
                                year: currentPage.content.thirdYear.text,
                                title: currentPage.content.thirdTitle.text,
                                subtitle:
                                    currentPage.content.thirdSubTitle.text,
                                content: currentPage.content.thirdText.text,

                                fontSize: {
                                    year: 'text-md md:text-lg lg:text-xl',
                                    title: 'text-4xl md:text-3xl lg:text-6xl',
                                    subtitle: 'text-2xl 2xl:text-3xl',
                                    content: 'text-md md:text-xl lg:text-base',
                                },
                                color: {
                                    year: 'text-selective_orange',
                                    pretitle: 'text-white',
                                    title: 'text-white',
                                    subtitle: 'text-white',
                                    content: 'text-white',
                                },
                            }"
                        >
                        </TimelineTitle>
                    </div>
                </div>

                <div class="card break-inside-avoid">
                    <div class="relative">
                        <hotspot-richmedia
                                :options="{
                                icon: 'diaporama',
                                collection: getRichmediaByCollection(
                                    currentPage,
                                    'Lancement des journées d’accueil des nouveaux arrivants en 2008'
                                ),
                            }"
                                class="-top-3 md:top-0 -right-2"
                        />
                    </div>

                    <TimelineTitle
                            :options="{
                            year: currentPage.content.fourthYear.text,
                            pretitle: currentPage.content.fourthPreTitle.text,
                            title: currentPage.content.fourthTitle.text,
                            content: currentPage.content.fourthText.text,
                            fontSize: {},
                            color: {
                                year: 'text-selective_orange',
                                title: 'text-selective_green',
                                subtitle: 'text-red-500',
                                content: 'text-black',
                            },
                            fontSize: {
                                year: 'text-md md:text-lg lg:text-xl',
                                pretitle: 'text-xl 2xl:text-2xl',
                                title: 'text-3xl 2xl:text-4xl',
                                subtitle: 'text-2xl md:text-2xl lg:text-3xl',
                                content: 'text-md md:text-xl lg:text-base',
                            },
                        }"
                    >
                        <div class="mx-auto">
                            <image-with-descriptions
                                    class="mt-1 mb-1"
                                    :options="{
                                    image:
                                        'pages/' +
                                        currentPage.slug +
                                        '/' +
                                        currentPage.images.image4.src,
                                    descriptions: [
                                        {
                                            text: currentPage.images.image4
                                                .edf,
                                            position: 'bottom-right', // top/bottom-left/right
                                            orientation: 'horizontal', // vertical, horizontal
                                            fontSize: 'text-xs md:text-base',
                                        },
                                    ],
                                }"
                            />
                        </div>
                    </TimelineTitle>
                </div>

                <div class="card break-inside-avoid">
                    <div class="relative pt-6 md:pt-8 lg:pt-0">
                        <hotspot-richmedia
                                :options="{
                                icon: 'diaporama',
                                collection: getRichmediaByCollection(
                                    currentPage,
                                    'Évolution de l’organisation du CIH en 2008'
                                ),
                            }"
                                class="top-2 md:top-0 2xl:top-12 -right-2"
                        />
                    </div>

                    <TimelineTitle
                            :options="{
                            year: currentPage.content.fifthYear.text,
                            pretitle: currentPage.content.fifthPreTitle.text,
                            title: currentPage.content.fifthTitle.text,
                            content: currentPage.content.fifthText.text,
                            fontSize: {},
                            color: {
                                year: 'text-selective_orange',
                                title: 'text-selective_green',
                                content: 'text-black',
                            },
                            fontSize: {
                                year: 'text-md md:text-lg lg:text-xl',
                                pretitle: 'text-xl 2xl:text-2xl',
                                title: 'text-3xl 2xl:text-4xl',
                                content: 'text-md md:text-xl lg:text-base',
                            },
                        }"
                    >
                        <div class="mx-auto">
                            <image-with-descriptions
                                    class="mt-1 mb-1"
                                    :options="{
                                    image:
                                        'pages/' +
                                        currentPage.slug +
                                        '/' +
                                        currentPage.images.image5.src,
                                    descriptions: [
                                        {
                                            text: currentPage.images.image5
                                                .text,
                                            position: 'bottom-right', // top/bottom-left/right
                                            orientation: 'horizontal', // vertical, horizontal
                                            fontSize: 'text-xs md:text-base',
                                        },
                                    ],
                                }"
                            />
                        </div>
                    </TimelineTitle>
                </div>

                <div class="card break-inside-avoid">
                            <TimelineTitle
                                    :options="{
                                    year: currentPage.content.sixthYear.text,
                                    pretitle:
                                        currentPage.content.sixthPreTitle.text,
                                    title: currentPage.content.sixthTitle.text,
                                    content: currentPage.content.sixthText.text,
                                    fontSize: {},
                                    color: {
                                        year: 'text-selective_orange',
                                        title: 'text-selective_green',
                                        content: 'text-black',
                                    },
                                    fontSize: {
                                        year: 'text-md md:text-lg lg:text-xl',
                                        pretitle: 'text-xl 2xl:text-2xl',
                                        title: 'text-3xl 2xl:text-4xl',
                                        content:
                                            'text-md md:text-xl lg:text-base',
                                    },
                                }"
                            >
                                <image-with-descriptions
                                        class="mt-1 mb-1"
                                        :options="{
                                        image:
                                            'pages/' +
                                            currentPage.slug +
                                            '/' +
                                            currentPage.images.image6.src,
                                        descriptions: [
                                            {
                                                text: currentPage.images.image6
                                                    .text,
                                                position: 'bottom-right', // top/bottom-left/right
                                                orientation: 'horizontal', // vertical, horizontal
                                                fontSize:
                                                    'text-xs md:text-base',
                                            },
                                        ],
                                    }"
                                />
                            </TimelineTitle>
                </div>

                <div class="card break-inside-avoid">

                    <TimelineTitle
                            :options="{
                                    year: currentPage.content.seventhYear.text,
                                    pretitle:
                                        currentPage.content.seventhPreTitle
                                            .text,
                                    title: currentPage.content.seventhTitle
                                        .text,
                                    content:
                                        currentPage.content.seventhText.text,
                                    fontSize: {},
                                    color: {
                                        year: 'text-selective_orange',
                                        title: 'text-selective_green',
                                        subtitle: 'text-red-500',
                                        content: 'text-black',
                                    },
                                    fontSize: {
                                        year: 'text-md md:text-lg lg:text-xl',
                                        pretitle: 'text-xl 2xl:text-2xl',
                                        title: 'text-3xl 2xl:text-4xl',
                                        subtitle:
                                            'text-2xl md:text-2xl lg:text-3xl',
                                        content:
                                            'text-md md:text-xl lg:text-base',
                                    },
                                }"
                    >
                    </TimelineTitle>

                </div>
            </div>
        </div>

        <timeline-carousel
                :options="{
                timeline: currentPage.timeline,
            }"
        />
    </section>
</template>

<script>
import PagesMixin from "@/mixins/PagesMixin";
import Paragraph from "../../components/Paragraph.vue";
import ArticleTitleTour from "../../components/ArticleTitleTour.vue";

export default {
    components: {Paragraph, ArticleTitleTour},
    name: "Page006",
    mixins: [PagesMixin],
};
</script>

<style scoped lang='scss'>
</style>
